import { useContext } from 'react';

import { NotificationsContext } from './context';

export const useNotificationsProvider = () => useContext(NotificationsContext);
